export const PARTNER_API_URL = process.env.REACT_APP_PARTNER_API_BASE_URL || '';

export const ADMIN_API_URL =
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  '';

export const API_TOKEN = process.env.REACT_APP_API_TOKEN;
export const VITE_AZURE_CLIENTID = process.env.REACT_APP_VITE_AZURE_CLIENTID;
export const VITE_AZURE_AUTHORITY = process.env.REACT_APP_VITE_AZURE_AUTHORITY;
export const DEPLOYED_APP_URL = process.env.REACT_APP_DEPLOYED_APP_URL || '';
export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE || 'IN';
